<template>
  <template-corporation :hasFinalTaxType="hasFinalTaxType">
    <div slot="tax">โดยปีนี้คุณจะเสียภาษีประมาณ {{ tax }} บาท</div>
  </template-corporation>
</template>

<script>
export default {
  name: "CorpDecision",
  props: ["hasFinalTaxType"],
  data() {
    const { corporation } = this.$store.getters["taxInfo/taxComparationInfo"];
    const corporateTax = corporation.tax.toLocaleString("th-TH");
    return {
      tax: corporateTax,
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatCalculation() {
      this.$router.push({
        path: "/info/vat_calculation",
      });
    },
    goPurchaseTax() {
      this.$router.push({
        path: "/info/purchase_tax",
      });
    },
  },
};
</script>

<style scoped></style>
